"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnairesContextProvider = exports.QuestionnairesContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var defaults_1 = require("./defaults");
var questionnaire_1 = require("../../services/questionnaire");
var user_1 = require("./user");
exports.QuestionnairesContext = (0, react_1.createContext)({
    fetchQuestionnaires: defaults_1.defaultConfig.fetchQuestionnaires,
    fetchQuestionnaire: defaults_1.defaultConfig.fetchQuestionnaire,
    fetchQuestionnairesAnswers: defaults_1.defaultConfig.fetchQuestionnairesAnswers,
    fetchQuestionnaireStars: defaults_1.defaultConfig.fetchQuestionnaireStars,
    sendQuestionnaireAnswer: defaults_1.defaultConfig.sendQuestionnaireAnswer,
    fetchQuestionnaireStarsByModel: defaults_1.defaultConfig.fetchQuestionnaireStarsByModel,
});
var QuestionnairesContextProvider = function (_a) {
    var children = _a.children, apiUrl = _a.apiUrl, ssrHydration = _a.ssrHydration;
    var token = (0, react_1.useContext)(user_1.UserContext).token;
    var fetchQuestionnaires = (0, react_1.useCallback)(function (model, id) {
        return questionnaire_1.getQuestionnaires.bind(null, apiUrl)(model, id);
    }, []);
    var fetchQuestionnaire = (0, react_1.useCallback)(function (modelTypeTitle, modelID, id) {
        return token
            ? questionnaire_1.getQuestionnaire.bind(null, apiUrl)(token, modelTypeTitle, modelID, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchQuestionnairesAnswers = (0, react_1.useCallback)(function (modelTypeTitle, modelID, id, params) {
        return questionnaire_1.getQuestionnairesAnswer.bind(null, apiUrl)(modelTypeTitle, modelID, id, params);
    }, []);
    var fetchQuestionnaireStars = (0, react_1.useCallback)(function (modelTypeTitle, modelID, id) {
        return questionnaire_1.getQuestionnaireStars.bind(null, apiUrl)(modelTypeTitle, modelID, id);
    }, []);
    var fetchQuestionnaireStarsByModel = (0, react_1.useCallback)(function (modelTypeTitle, modelID) {
        return questionnaire_1.getQuestionnaireStarsByModel.bind(null, apiUrl)(modelTypeTitle, modelID);
    }, []);
    var sendQuestionnaireAnswer = (0, react_1.useCallback)(function (model, modelID, id, body) {
        return token
            ? questionnaire_1.questionnaireAnswer.bind(null, apiUrl)(token, model, modelID, id, body)
            : Promise.reject("noToken");
    }, [token]);
    return ((0, jsx_runtime_1.jsx)(exports.QuestionnairesContext.Provider, __assign({ value: {
            fetchQuestionnaires: fetchQuestionnaires,
            fetchQuestionnaire: fetchQuestionnaire,
            fetchQuestionnairesAnswers: fetchQuestionnairesAnswers,
            sendQuestionnaireAnswer: sendQuestionnaireAnswer,
            fetchQuestionnaireStars: fetchQuestionnaireStars,
            fetchQuestionnaireStarsByModel: fetchQuestionnaireStarsByModel,
        } }, { children: children })));
};
exports.QuestionnairesContextProvider = QuestionnairesContextProvider;
